export const Dash = ({ color }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1426 1.22217H22.0625C23.6843 1.22217 25 2.54925 25 4.18639V8.13909C25 9.77499 23.6843 11.1033 22.0625 11.1033H18.1426C16.5195 11.1033 15.2039 9.77499 15.2039 8.13909V4.18639C15.2039 2.54925 16.5195 1.22217 18.1426 1.22217Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.93871 1.22217H7.85739C9.48044 1.22217 10.7961 2.54925 10.7961 4.18639V8.13909C10.7961 9.77499 9.48044 11.1033 7.85739 11.1033H3.93871C2.31565 11.1033 1 9.77499 1 8.13909V4.18639C1 2.54925 2.31565 1.22217 3.93871 1.22217Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.93871 15.3408H7.85739C9.48044 15.3408 10.7961 16.6679 10.7961 18.3063V22.2577C10.7961 23.8949 9.48044 25.222 7.85739 25.222H3.93871C2.31565 25.222 1 23.8949 1 22.2577V18.3063C1 16.6679 2.31565 15.3408 3.93871 15.3408Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1426 15.3408H22.0625C23.6843 15.3408 25 16.6679 25 18.3063V22.2577C25 23.8949 23.6843 25.222 22.0625 25.222H18.1426C16.5195 25.222 15.2039 23.8949 15.2039 22.2577V18.3063C15.2039 16.6679 16.5195 15.3408 18.1426 15.3408Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Location = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-map-pin"
    >
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
  );
};

export const Transactions = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M7.44572 11.0643V19.2965"
        stroke="#808191"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M13.0457 7.12463V19.2959"
        stroke="#808191"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M18.5543 15.4141V19.2961"
        stroke="#808191"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6229 1.22217H7.37714C3.45714 1.22217 1 3.99667 1 7.92436V18.52C1 22.4477 3.44571 25.2222 7.37714 25.2222H18.6229C22.5543 25.2222 25 22.4477 25 18.52V7.92436C25 3.99667 22.5543 1.22217 18.6229 1.22217Z"
        stroke="#808191"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Reports = ({ color }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M18.2322 18.7871H7.83435"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M18.2322 13.3293H7.83435"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M11.8022 7.88424H7.83459"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5093 1.22217C18.5093 1.22217 7.45328 1.22738 7.436 1.22738C3.46121 1.24954 1 3.61695 1 7.22803V19.2163C1 22.8456 3.47993 25.2222 7.48929 25.2222C7.48929 25.2222 18.5438 25.2183 18.5626 25.2183C22.5374 25.1961 25 22.8274 25 19.2163V7.22803C25 3.5987 22.5186 1.22217 18.5093 1.22217Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Setting = () => {
  return (
    <svg
      width="23"
      height="25"
      viewBox="0 0 23 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.98065 4.77512L9.26636 1.69179C10.8232 0.783651 12.7483 0.783651 14.3051 1.69179L19.5908 4.77512C21.1269 5.67118 22.0714 7.31568 22.0714 9.09402V15.3503C22.0714 17.1287 21.1269 18.7732 19.5908 19.6692L14.3051 22.7525C12.7483 23.6607 10.8232 23.6607 9.26636 22.7525L3.98065 19.6692C2.44456 18.7732 1.5 17.1287 1.5 15.3503V9.09402C1.5 7.31568 2.44456 5.67118 3.98065 4.77512Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M11.7857 15.6508C9.8922 15.6508 8.35718 14.1157 8.35718 12.2222C8.35718 10.3286 9.8922 8.79361 11.7857 8.79361C13.6793 8.79361 15.2143 10.3286 15.2143 12.2222C15.2143 14.1157 13.6793 15.6508 11.7857 15.6508Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const Admin = ({ color }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0002 6.99951C12.0939 6.99951 11.208 7.26825 10.4545 7.77173C9.70098 8.27521 9.11369 8.99084 8.76688 9.8281C8.42008 10.6654 8.32934 11.5867 8.50614 12.4755C8.68294 13.3643 9.11934 14.1808 9.76015 14.8216C10.401 15.4624 11.2174 15.8988 12.1062 16.0756C12.9951 16.2524 13.9164 16.1617 14.7536 15.8149C15.5909 15.4681 16.3065 14.8808 16.81 14.1272C17.3135 13.3737 17.5822 12.4878 17.5822 11.5816C17.5822 10.3663 17.0995 9.20087 16.2402 8.34157C15.3809 7.48226 14.2154 6.99951 13.0002 6.99951Z"
        fill={color}
      />
      <path
        d="M18.9603 19.3175C19.816 20.1619 20.3057 21.3087 20.324 22.5107L20.324 24.7769H5.67603V22.5107C5.69429 21.3087 6.18403 20.1619 7.03973 19.3175C7.89543 18.4732 9.0486 17.9987 10.2508 17.9965H15.7492C16.9514 17.9987 18.1046 18.4732 18.9603 19.3175Z"
        fill={color}
      />
      <path
        d="M7 1.22217H19C22.3137 1.22217 25 3.90846 25 7.22217V19.2222C25 22.5359 22.3137 25.2222 19 25.2222H7C3.68629 25.2222 1 22.5359 1 19.2222V7.22217C1 3.90846 3.68629 1.22217 7 1.22217Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const Partner = ({ color }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0002 6.99951C12.0939 6.99951 11.208 7.26825 10.4545 7.77173C9.70098 8.27521 9.11369 8.99084 8.76688 9.8281C8.42008 10.6654 8.32934 11.5867 8.50614 12.4755C8.68294 13.3643 9.11934 14.1808 9.76015 14.8216C10.401 15.4624 11.2174 15.8988 12.1062 16.0756C12.9951 16.2524 13.9164 16.1617 14.7536 15.8149C15.5909 15.4681 16.3065 14.8808 16.81 14.1272C17.3135 13.3737 17.5822 12.4878 17.5822 11.5816C17.5822 10.3663 17.0995 9.20087 16.2402 8.34157C15.3809 7.48226 14.2154 6.99951 13.0002 6.99951Z"
        fill={color}
      />
      <path
        d="M18.9603 19.3175C19.816 20.1619 20.3057 21.3087 20.324 22.5107L20.324 24.7769H5.67603V22.5107C5.69429 21.3087 6.18403 20.1619 7.03973 19.3175C7.89543 18.4732 9.0486 17.9987 10.2508 17.9965H15.7492C16.9514 17.9987 18.1046 18.4732 18.9603 19.3175Z"
        fill={color}
      />
      <path
        d="M7 1.22217H19C22.3137 1.22217 25 3.90846 25 7.22217V19.2222C25 22.5359 22.3137 25.2222 19 25.2222H7C3.68629 25.2222 1 22.5359 1 19.2222V7.22217C1 3.90846 3.68629 1.22217 7 1.22217Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const Sidelift = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12L3 12"
        stroke="#11142D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 20H13"
        stroke="#808191"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.301406"
        d="M22 4L13 4"
        stroke="#808191"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 17L2 12L7 7"
        stroke="#11142D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      class="feather feather-search"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  );
};

export const StataIcon1 = () => {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.250809"
        y="0.717041"
        width="64.8232"
        height="64.8232"
        rx="32.4116"
        fill="#3A36DB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.8217 22.8657C37.5034 22.8657 38.184 22.9618 38.8312 23.179C42.8189 24.4754 44.2558 28.851 43.0555 32.6756C42.3748 34.63 41.262 36.4137 39.8046 37.8711C37.7184 39.8915 35.429 41.6849 32.9647 43.2298L32.6946 43.393L32.4137 43.219C29.9407 41.6849 27.6384 39.8915 25.5327 37.8603C24.085 36.4029 22.9711 34.63 22.2797 32.6756C21.0588 28.851 22.4957 24.4754 26.5267 23.1563C26.84 23.0482 27.163 22.9726 27.4871 22.9305H27.6168C27.9204 22.8862 28.2218 22.8657 28.5243 22.8657H28.6431C29.3238 22.8862 29.9828 23.005 30.6213 23.2222H30.6851C30.7283 23.2427 30.7607 23.2654 30.7823 23.2859C31.0211 23.3626 31.2469 23.4491 31.4629 23.5679L31.8735 23.7516C31.9727 23.8045 32.084 23.8853 32.1803 23.9552C32.2412 23.9995 32.2962 24.0393 32.3381 24.0649C32.3557 24.0753 32.3736 24.0857 32.3917 24.0963C32.4843 24.1504 32.5808 24.2067 32.6622 24.2691C33.8625 23.3518 35.3199 22.8548 36.8217 22.8657ZM39.6955 30.6444C40.1384 30.6325 40.5166 30.2771 40.549 29.8223V29.6937C40.5814 28.1801 39.6641 26.8091 38.2694 26.2797C37.8264 26.1273 37.3402 26.3661 37.1782 26.8199C37.0269 27.2736 37.2646 27.7706 37.7184 27.9316C38.4109 28.1909 38.8744 28.8726 38.8744 29.6278V29.6613C38.8539 29.9087 38.9284 30.1475 39.0797 30.3311C39.2309 30.5148 39.4578 30.6217 39.6955 30.6444Z"
        fill="#4263EB"
      />
    </svg>
  );
};
export const Stock = () => {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.2"
        x="0.205811"
        y="0.717041"
        width="64.8232"
        height="64.8232"
        rx="32.4116"
        fill="#03A89E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.0357 25.6551C36.3761 25.6597 36.7173 25.6644 37.0597 25.6679C40.7388 25.6679 43.4212 28.2908 43.4212 31.9129V36.5655C43.4212 40.1876 40.7388 42.8105 37.0597 42.8105C35.586 42.8417 34.1123 42.8521 32.6279 42.8521C31.1436 42.8521 29.6487 42.8417 28.1749 42.8105C24.4959 42.8105 21.8135 40.1876 21.8135 36.5655V31.9129C21.8135 28.2908 24.4959 25.6679 28.1855 25.6679C29.5744 25.6471 30.9952 25.6263 32.4371 25.6263V25.4494C32.4371 24.7312 31.8328 24.1483 31.1118 24.1483H30.0622C28.8641 24.1483 27.8887 23.1907 27.8887 22.025C27.8887 21.5983 28.2491 21.2444 28.6838 21.2444C29.1291 21.2444 29.479 21.5983 29.479 22.025C29.479 22.3373 29.7441 22.5871 30.0622 22.5871H31.1118C32.7128 22.5975 34.0169 23.8777 34.0275 25.4389V25.6367C34.6958 25.6367 35.3642 25.6459 36.0357 25.6551ZM31.3769 35.0146H30.2636V36.1179C30.2636 36.5446 29.9031 36.8985 29.4684 36.8985C29.0231 36.8985 28.6732 36.5446 28.6732 36.1179V35.0146H27.5494C27.1147 35.0146 26.7542 34.6711 26.7542 34.234C26.7542 33.8073 27.1147 33.4534 27.5494 33.4534H28.6732V32.3605C28.6732 31.9338 29.0231 31.5799 29.4684 31.5799C29.9031 31.5799 30.2636 31.9338 30.2636 32.3605V33.4534H31.3769C31.8116 33.4534 32.172 33.8073 32.172 34.234C32.172 34.6711 31.8116 35.0146 31.3769 35.0146ZM35.8829 33.2556H35.9889C36.4236 33.2556 36.7841 32.9121 36.7841 32.475C36.7841 32.0482 36.4236 31.6944 35.9889 31.6944H35.8829C35.4376 31.6944 35.0877 32.0482 35.0877 32.475C35.0877 32.9121 35.4376 33.2556 35.8829 33.2556ZM37.6959 36.8361H37.8019C38.2366 36.8361 38.5971 36.4926 38.5971 36.0555C38.5971 35.6287 38.2366 35.2748 37.8019 35.2748H37.6959C37.2495 35.2748 36.9007 35.6287 36.9007 36.0555C36.9007 36.4926 37.2495 36.8361 37.6959 36.8361Z"
        fill="#03A89E"
      />
    </svg>
  );
};

export const Cashier = ({ color }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0002 6.99951C12.0939 6.99951 11.208 7.26825 10.4545 7.77173C9.70101 8.27521 9.11371 8.99084 8.7669 9.8281C8.4201 10.6654 8.32936 11.5867 8.50616 12.4755C8.68296 13.3643 9.11936 14.1808 9.76017 14.8216C10.401 15.4624 11.2174 15.8988 12.1063 16.0756C12.9951 16.2524 13.9164 16.1617 14.7537 15.8149C15.5909 15.4681 16.3066 14.8808 16.81 14.1272C17.3135 13.3737 17.5823 12.4878 17.5823 11.5816C17.5823 10.3663 17.0995 9.20087 16.2402 8.34157C15.3809 7.48226 14.2154 6.99951 13.0002 6.99951Z"
        fill={color}
      />
      <path
        d="M18.9603 19.3177C19.816 20.1621 20.3057 21.3088 20.324 22.5108L20.324 24.777H5.67602V22.5108C5.69429 21.3088 6.18403 20.1621 7.03973 19.3177C7.89543 18.4733 9.04859 17.9988 10.2508 17.9966H15.7492C16.9514 17.9988 18.1046 18.4733 18.9603 19.3177Z"
        fill={color}
      />
      <path
        d="M7 1.22217H19C22.3137 1.22217 25 3.90846 25 7.22217V19.2222C25 22.5359 22.3137 25.2222 19 25.2222H7C3.68629 25.2222 1 22.5359 1 19.2222V7.22217C1 3.90846 3.68629 1.22217 7 1.22217Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
export const Orders = ({ color }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M7.44572 11.0642V19.2964"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M13.0457 7.12476V19.296"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M18.5543 15.4141V19.2961"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6229 1.22217H7.37714C3.45714 1.22217 1 3.99667 1 7.92436V18.52C1 22.4477 3.44571 25.2222 7.37714 25.2222H18.6229C22.5543 25.2222 25 22.4477 25 18.52V7.92436C25 3.99667 22.5543 1.22217 18.6229 1.22217Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Drink = ({ color }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1069_1394)">
        <path
          d="M24.66 13.15C24.6052 13.0666 24.5415 12.9895 24.47 12.92C24.3851 12.8497 24.2948 12.7862 24.2 12.73V12.51C24.2141 11.519 24.0152 10.5364 23.6166 9.62896C23.2181 8.72147 22.6293 7.91018 21.89 7.25C21.6393 7.02751 21.4378 6.75519 21.2983 6.45042C21.1589 6.14565 21.0845 5.81514 21.08 5.48V1.62C21.08 1.40726 21.0381 1.1966 20.9567 1.00005C20.8753 0.803504 20.7559 0.624917 20.6055 0.474486C20.4551 0.324055 20.2765 0.204727 20.0799 0.123315C19.8834 0.0419022 19.6727 0 19.46 0H16.46C16.0312 0.00262296 15.6206 0.174142 15.3174 0.477385C15.0141 0.780627 14.8426 1.19116 14.84 1.62V5.44C14.8383 5.77174 14.7661 6.09932 14.6282 6.40103C14.4903 6.70274 14.2898 6.97168 14.04 7.19C13.4141 7.76191 12.893 8.43874 12.5 9.19C12.1146 8.4393 11.6001 7.7623 10.98 7.19C10.7279 6.96872 10.5254 6.69663 10.3858 6.3916C10.2462 6.08656 10.1726 5.75545 10.17 5.42V1.62C10.1674 1.19116 9.99585 0.780627 9.69261 0.477385C9.38937 0.174142 8.97884 0.00262296 8.55 0H5.55C5.12116 0.00262296 4.71062 0.174142 4.40738 0.477385C4.10414 0.780627 3.93262 1.19116 3.92999 1.62V5.44C3.92768 5.77067 3.85621 6.09719 3.72015 6.39858C3.5841 6.69997 3.38648 6.96956 3.14 7.19C2.39711 7.84995 1.80529 8.66237 1.40492 9.57183C1.00455 10.4813 0.805031 11.4664 0.819992 12.46V12.73L0.729996 12.78C0.563904 12.8912 0.421217 13.0339 0.309998 13.2C0.134325 13.4561 0.0402019 13.7594 0.0399933 14.07V23.42C0.0399933 23.8337 0.204361 24.2305 0.496918 24.5231C0.789474 24.8156 1.18625 24.98 1.59999 24.98H23.41C23.7206 24.9798 24.0239 24.8857 24.28 24.71C24.4484 24.6017 24.5916 24.4584 24.7 24.29C24.8757 24.0339 24.9698 23.7306 24.97 23.42V14.02C24.9581 13.7051 24.8499 13.4015 24.66 13.15ZM21.84 23.37H1.56V14.02H23.37V23.37H21.84ZM4.14 8.37C4.54924 8.00314 4.87721 7.55473 5.10281 7.05357C5.32842 6.55241 5.44668 6.00959 5.45 5.46V3.12H8.56999V5.43C8.57547 5.98311 8.69562 6.52907 8.92282 7.03339C9.15002 7.53771 9.47935 7.98942 9.89 8.36C10.4656 8.87456 10.9234 9.50718 11.2323 10.2147C11.5412 10.9223 11.6939 11.6881 11.68 12.46H4.67999C4.76126 11.4722 5.2283 10.5561 5.98 9.91C6.13358 9.77194 6.22615 9.57861 6.2374 9.3724C6.24864 9.1662 6.17765 8.96394 6.03999 8.81C5.90055 8.65874 5.70761 8.56784 5.50218 8.55663C5.29676 8.54543 5.09507 8.6148 4.94 8.75C4.39966 9.21091 3.96006 9.77821 3.64865 10.4165C3.33724 11.0548 3.16068 11.7504 3.12999 12.46H2.34999C2.33597 11.6866 2.48858 10.9193 2.79744 10.2101C3.1063 9.5009 3.5642 8.86651 4.14 8.35V8.37ZM5.50999 1.58H8.50999C8.52591 1.58 8.54118 1.58632 8.55243 1.59757C8.56368 1.60882 8.56999 1.62409 8.56999 1.64V2.36H5.45V1.64C5.44668 1.63067 5.44572 1.62066 5.4472 1.61088C5.44869 1.60109 5.45259 1.59182 5.45853 1.5839C5.46447 1.57598 5.47228 1.56965 5.48126 1.56548C5.49024 1.56131 5.50011 1.55943 5.50999 1.56V1.58ZM15.04 8.37C15.4525 8.00525 15.7834 7.55747 16.0108 7.056C16.2383 6.55452 16.3573 6.01065 16.36 5.46V3.12H19.47V5.43C19.4767 5.98385 19.5984 6.53027 19.8274 7.03463C20.0563 7.539 20.3875 7.99032 20.8 8.36C21.374 8.87581 21.8308 9.50866 22.1396 10.2159C22.4483 10.9232 22.6019 11.6884 22.59 12.46H15.59C15.6281 11.9703 15.7626 11.4929 15.9857 11.0553C16.2088 10.6177 16.5161 10.2285 16.89 9.91C17.0436 9.77194 17.1361 9.57861 17.1474 9.3724C17.1586 9.1662 17.0877 8.96394 16.95 8.81C16.8106 8.65874 16.6176 8.56784 16.4122 8.55663C16.2068 8.54543 16.0051 8.6148 15.85 8.75C15.3087 9.2108 14.8679 9.77786 14.5548 10.416C14.2418 11.0542 14.0631 11.7499 14.03 12.46H13.2C13.1922 11.6828 13.3526 10.9131 13.6702 10.2036C13.9878 9.49422 14.4551 8.86189 15.04 8.35V8.37ZM16.42 1.58H19.42C19.4359 1.58 19.4512 1.58632 19.4624 1.59757C19.4737 1.60882 19.48 1.62409 19.48 1.64V2.36H16.37V1.64C16.3669 1.63145 16.3658 1.62232 16.3668 1.61329C16.3677 1.60425 16.3707 1.59556 16.3756 1.58785C16.3804 1.58015 16.3869 1.57364 16.3946 1.56881C16.4023 1.56399 16.411 1.56098 16.42 1.56V1.58Z"
          fill={color}
        />
        <path
          opacity="0.4"
          d="M21.81 18.7301C21.6031 18.7301 21.4047 18.8123 21.2585 18.9586C21.1122 19.1048 21.03 19.3032 21.03 19.5101V21.0301H3.89V17.1401C3.89132 17.0382 3.87238 16.9369 3.83427 16.8424C3.79617 16.7478 3.73966 16.6617 3.66803 16.5892C3.5964 16.5166 3.51107 16.459 3.41699 16.4197C3.32291 16.3803 3.22196 16.3601 3.12 16.3601C2.91313 16.3601 2.71473 16.4423 2.56845 16.5886C2.42217 16.7348 2.34 16.9332 2.34 17.1401V21.8101C2.34 22.017 2.42217 22.2154 2.56845 22.3617C2.71473 22.5079 2.91313 22.5901 3.12 22.5901H21.81C22.0169 22.5901 22.2153 22.5079 22.3615 22.3617C22.5078 22.2154 22.59 22.017 22.59 21.8101V19.4801C22.5822 19.2785 22.4966 19.0877 22.3512 18.9479C22.2058 18.808 22.0118 18.73 21.81 18.7301V18.7301Z"
          fill={color}
        />
        <path
          opacity="0.4"
          d="M8.95999 18.73H15.96C16.4019 18.6293 16.7964 18.3815 17.079 18.0273C17.3617 17.673 17.5156 17.2332 17.5156 16.78C17.5156 16.3268 17.3617 15.8871 17.079 15.5328C16.7964 15.1785 16.4019 14.9307 15.96 14.83H8.95999C8.6671 14.7633 8.36293 14.7634 8.07007 14.8303C7.77721 14.8972 7.50319 15.0292 7.26836 15.2166C7.03352 15.4039 6.8439 15.6417 6.71358 15.9124C6.58326 16.1831 6.51559 16.4796 6.51559 16.78C6.51559 17.0804 6.58326 17.377 6.71358 17.6477C6.8439 17.9183 7.03352 18.1562 7.26836 18.3435C7.50319 18.5308 7.77721 18.6629 8.07007 18.7298C8.36293 18.7967 8.6671 18.7968 8.95999 18.73V18.73ZM8.95999 16.39H15.96C16.0634 16.39 16.1626 16.4311 16.2358 16.5043C16.3089 16.5774 16.35 16.6766 16.35 16.78C16.3475 16.8827 16.3056 16.9804 16.233 17.053C16.1604 17.1256 16.0626 17.1675 15.96 17.17H8.95999C8.85656 17.17 8.75736 17.1289 8.68422 17.0558C8.61108 16.9827 8.56999 16.8835 8.56999 16.78C8.56425 16.726 8.57015 16.6714 8.5873 16.6199C8.60444 16.5683 8.63244 16.5211 8.6694 16.4813C8.70636 16.4415 8.75143 16.41 8.80156 16.3891C8.85169 16.3682 8.9057 16.3583 8.95999 16.36V16.39Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1069_1394">
          <rect width="24.93" height="24.93" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Event = ({ color }) => {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.41216 12.7988C3.01628 13.1257 4.24131 14.5421 4.24131 16.2352C4.24131 17.9284 3.01616 19.3448 1.41192 19.6716C1.41961 21.8531 1.72021 22.949 2.33285 23.5556C2.95596 24.1726 4.08978 24.4705 6.35294 24.4705H17.6471C19.9102 24.4705 21.044 24.1726 21.6672 23.5556C22.2263 23.002 22.5255 22.0408 22.5794 20.2187C20.9818 19.8911 19.7587 18.4886 19.7587 16.7955C19.7587 15.0905 20.9757 13.6925 22.5762 13.3701V12.8852C22.5762 10.6462 22.2758 9.5293 21.6551 8.91476C21.032 8.29781 19.8982 7.9999 17.635 7.9999H6.35294C4.08977 7.9999 2.95935 8.29783 2.33781 8.91432C1.72592 9.52124 1.42579 10.6175 1.41216 12.7988ZM1.34362 7.91199C2.41379 6.85051 4.10087 6.58813 6.35294 6.58813H17.635C19.8871 6.58813 21.5768 6.85054 22.6484 7.91155C23.7225 8.97497 23.988 10.6537 23.988 12.8852V14.0059C23.988 14.3957 23.6719 14.7117 23.2821 14.7117C22.1101 14.7117 21.1705 15.6441 21.1705 16.7955C21.1705 17.9331 22.1202 18.8793 23.2941 18.8793C23.684 18.8793 24 19.1953 24 19.5852C24 21.8167 23.7345 23.4954 22.6605 24.5588C21.5889 25.6198 19.8991 25.8823 17.6471 25.8823H6.35294C4.10087 25.8823 2.41115 25.6198 1.33955 24.5588C0.265506 23.4954 0 21.8167 0 19.5852V19.0368C0 18.6469 0.316034 18.3309 0.705882 18.3309C1.87591 18.3309 2.82955 17.3766 2.82955 16.2352C2.82955 15.0938 1.87591 14.1395 0.705882 14.1395C0.316034 14.1395 0 13.8235 0 13.4336V12.8852L2.58053e-06 12.8833C0.00600972 10.6529 0.272005 8.97489 1.34362 7.91199Z"
        fill={color}
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1539 1.9033C11.6452 2.27067 11.0671 2.84544 10.3701 3.66412L7.88086 6.58824H16.2456C16.1388 5.72943 16.3085 4.83459 16.7542 4.08375L16.397 3.66412C15.7001 2.84544 15.1219 2.27067 14.6133 1.9033C14.1104 1.54013 13.7199 1.41176 13.3836 1.41176C13.0472 1.41176 12.6567 1.54013 12.1539 1.9033ZM15.4398 0.758798C16.0853 1.22498 16.7497 1.90055 17.472 2.74899L18.1846 3.58603C18.4091 3.84976 18.4091 4.23743 18.1846 4.50116C17.6167 5.16816 17.4669 6.18585 17.8041 7.03309C17.8906 7.25051 17.8638 7.49669 17.7324 7.69036C17.6011 7.88403 17.3823 8 17.1483 8H6.35294C6.07771 8 5.82757 7.84002 5.71214 7.59016C5.59671 7.3403 5.63703 7.04613 5.81544 6.83655L9.29512 2.74899C10.0174 1.90055 10.6818 1.22498 11.3273 0.758798C11.9786 0.288412 12.654 0 13.3836 0C14.1131 0 14.7885 0.288412 15.4398 0.758798Z"
        fill={color}
      />
      <path
        opacity="0.5"
        d="M9.17647 7.29419L9.17647 25.1765"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="5 5"
      />
    </svg>
  );
};

export const SmartGateWhite = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M7 1H19C22.3137 1 25 3.68629 25 7V19C25 22.3137 22.3137 25 19 25H7C3.68629 25 1 22.3137 1 19V7C1 3.68629 3.68629 1 7 1Z"
        stroke="#808191"
        strokeWidth="1.5"
      />
      <g clipPath="url(#clip0_644_1660)">
        <path
          d="M3.49854 8.95019C3.49854 8.67405 3.72239 8.4502 3.99854 8.4502H7.52403C7.80018 8.4502 8.02404 8.67405 8.02404 8.9502V20.5C8.02404 20.7761 7.80018 21 7.52404 21H3.99854C3.72239 21 3.49854 20.7761 3.49854 20.5V8.95019ZM5.23141 13.6275C5.23141 13.9037 5.45527 14.1275 5.73141 14.1275H5.83766C6.1138 14.1275 6.33766 13.9037 6.33766 13.6275V12.3758C6.33766 12.0996 6.1138 11.8758 5.83766 11.8758H5.73141C5.45527 11.8758 5.23141 12.0996 5.23141 12.3758V13.6275ZM5.22766 10.2092C5.22766 10.4853 5.45152 10.7092 5.72766 10.7092H5.83616C6.1123 10.7092 6.33616 10.4853 6.33616 10.2092V10.102C6.33616 9.8259 6.1123 9.60204 5.83616 9.60204H5.72766C5.45152 9.60204 5.22766 9.8259 5.22766 10.102V10.2092Z"
          fill="#808191"
        />
        <path
          d="M22.6984 20.5C22.6984 20.7761 22.4746 21 22.1984 21H18.6748C18.3987 21 18.1748 20.7761 18.1748 20.5V8.95019C18.1748 8.67405 18.3987 8.4502 18.6748 8.4502H22.1984C22.4746 8.4502 22.6984 8.67405 22.6984 8.9502V20.5ZM19.8563 13.6234C19.8563 13.8995 20.0802 14.1234 20.3563 14.1234H20.4581C20.7342 14.1234 20.9581 13.8995 20.9581 13.6234V12.3731C20.9581 12.097 20.7342 11.8731 20.4581 11.8731H20.3563C20.0802 11.8731 19.8563 12.097 19.8563 12.3731V13.6234ZM20.3593 9.59711C20.0832 9.59711 19.8593 9.82097 19.8593 10.0971V10.2122C19.8593 10.4883 20.0832 10.7122 20.3593 10.7122H20.4592C20.7353 10.7122 20.9592 10.4883 20.9592 10.2122V10.0971C20.9592 9.82097 20.7353 9.59711 20.4592 9.59711H20.3593Z"
          fill="#808191"
        />
        <path
          d="M7.5375 5H4C3.72386 5 3.5 5.22386 3.5 5.5V6.8128C3.5 7.08894 3.72386 7.3128 4 7.3128H7.5375C7.81364 7.3128 8.0375 7.08894 8.0375 6.8128V5.5C8.0375 5.22386 7.81364 5 7.5375 5Z"
          fill="#808191"
        />
        <path
          d="M22.2001 5H18.6626C18.3865 5 18.1626 5.22386 18.1626 5.5V6.8128C18.1626 7.08894 18.3865 7.3128 18.6626 7.3128H22.2001C22.4762 7.3128 22.7001 7.08894 22.7001 6.8128V5.5C22.7001 5.22386 22.4762 5 22.2001 5Z"
          fill="#808191"
        />
        <path
          d="M9.16846 16.8712V7.4585C9.50971 7.62949 9.83746 7.76636 10.1378 7.94911C11.0817 8.5239 11.7575 9.33982 12.1921 10.3616C12.3155 10.6509 12.4422 10.9391 12.5566 11.2337C12.5683 11.2667 12.5734 11.3018 12.5714 11.3368C12.5695 11.3718 12.5606 11.4061 12.5453 11.4376C11.4391 13.2376 10.3287 15.0349 9.21421 16.8295C9.20025 16.8448 9.18493 16.8587 9.16846 16.8712Z"
          fill="#BFC0C8"
        />
        <path
          d="M17.0299 7.68369V16.8799C16.9856 16.8189 16.9526 16.7787 16.9256 16.7347C15.8434 14.9858 14.7611 13.2371 13.6789 11.4884C13.6482 11.4468 13.6295 11.3974 13.6247 11.3457C13.62 11.294 13.6294 11.242 13.6519 11.1954C13.9856 10.3612 14.418 9.59535 15.057 8.95838C15.6046 8.41084 16.2548 7.97928 16.9695 7.689C16.9893 7.68492 17.0096 7.68314 17.0299 7.68369Z"
          fill="#BFC0C8"
        />
      </g>
      <defs>
        <clipPath id="clip0_644_1660">
          <rect
            width="19.2"
            height="16"
            fill="white"
            transform="translate(3.5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SmartGateBlue = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M7 1H19C22.3137 1 25 3.68629 25 7V19C25 22.3137 22.3137 25 19 25H7C3.68629 25 1 22.3137 1 19V7C1 3.68629 3.68629 1 7 1Z"
        fill="#4263EB"
        stroke="#4263EB"
        strokeWidth="1.5"
      />
      <g clipPath="url(#clip0_644_1659)">
        <path
          d="M3.49854 8.95019C3.49854 8.67405 3.72239 8.4502 3.99854 8.4502H7.52403C7.80018 8.4502 8.02404 8.67405 8.02404 8.9502V20.5C8.02404 20.7761 7.80018 21 7.52404 21H3.99854C3.72239 21 3.49854 20.7761 3.49854 20.5V8.95019ZM5.23141 13.6275C5.23141 13.9037 5.45527 14.1275 5.73141 14.1275H5.83766C6.1138 14.1275 6.33766 13.9037 6.33766 13.6275V12.3758C6.33766 12.0996 6.1138 11.8758 5.83766 11.8758H5.73141C5.45527 11.8758 5.23141 12.0996 5.23141 12.3758V13.6275ZM5.22766 10.2092C5.22766 10.4853 5.45152 10.7092 5.72766 10.7092H5.83616C6.1123 10.7092 6.33616 10.4853 6.33616 10.2092V10.102C6.33616 9.8259 6.1123 9.60204 5.83616 9.60204H5.72766C5.45152 9.60204 5.22766 9.8259 5.22766 10.102V10.2092Z"
          fill="white"
        />
        <path
          d="M22.6984 20.5C22.6984 20.7761 22.4746 21 22.1984 21H18.6748C18.3987 21 18.1748 20.7761 18.1748 20.5V8.95019C18.1748 8.67405 18.3987 8.4502 18.6748 8.4502H22.1984C22.4746 8.4502 22.6984 8.67405 22.6984 8.9502V20.5ZM19.8563 13.6234C19.8563 13.8995 20.0802 14.1234 20.3563 14.1234H20.4581C20.7342 14.1234 20.9581 13.8995 20.9581 13.6234V12.3731C20.9581 12.097 20.7342 11.8731 20.4581 11.8731H20.3563C20.0802 11.8731 19.8563 12.097 19.8563 12.3731V13.6234ZM20.3593 9.59711C20.0832 9.59711 19.8593 9.82097 19.8593 10.0971V10.2122C19.8593 10.4883 20.0832 10.7122 20.3593 10.7122H20.4592C20.7353 10.7122 20.9592 10.4883 20.9592 10.2122V10.0971C20.9592 9.82097 20.7353 9.59711 20.4592 9.59711H20.3593Z"
          fill="white"
        />
        <path
          d="M7.5375 5H4C3.72386 5 3.5 5.22386 3.5 5.5V6.8128C3.5 7.08894 3.72386 7.3128 4 7.3128H7.5375C7.81364 7.3128 8.0375 7.08894 8.0375 6.8128V5.5C8.0375 5.22386 7.81364 5 7.5375 5Z"
          fill="white"
        />
        <path
          d="M22.2001 5H18.6626C18.3865 5 18.1626 5.22386 18.1626 5.5V6.8128C18.1626 7.08894 18.3865 7.3128 18.6626 7.3128H22.2001C22.4762 7.3128 22.7001 7.08894 22.7001 6.8128V5.5C22.7001 5.22386 22.4762 5 22.2001 5Z"
          fill="white"
        />
        <path
          d="M9.16846 16.8712V7.4585C9.50971 7.62949 9.83746 7.76636 10.1378 7.94911C11.0817 8.5239 11.7575 9.33982 12.1921 10.3616C12.3155 10.6509 12.4422 10.9391 12.5566 11.2337C12.5683 11.2667 12.5734 11.3018 12.5714 11.3368C12.5695 11.3718 12.5606 11.4061 12.5453 11.4376C11.4391 13.2376 10.3287 15.0349 9.21421 16.8295C9.20025 16.8448 9.18493 16.8587 9.16846 16.8712Z"
          fill="white"
        />
        <path
          d="M17.0299 7.68369V16.8799C16.9856 16.8189 16.9526 16.7787 16.9256 16.7347C15.8434 14.9858 14.7611 13.2371 13.6789 11.4884C13.6482 11.4468 13.6295 11.3974 13.6247 11.3457C13.62 11.294 13.6294 11.242 13.6519 11.1954C13.9856 10.3612 14.418 9.59535 15.057 8.95838C15.6046 8.41084 16.2548 7.97928 16.9695 7.689C16.9893 7.68492 17.0096 7.68314 17.0299 7.68369Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_644_1659">
          <rect
            width="19.2"
            height="16"
            fill="white"
            transform="translate(3.5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TableWhite = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M7 1.22217H19C22.3137 1.22217 25 3.90846 25 7.22217V19.2222C25 22.5359 22.3137 25.2222 19 25.2222H7C3.68629 25.2222 1 22.5359 1 19.2222V7.22217C1 3.90846 3.68629 1.22217 7 1.22217Z"
        stroke="#808191"
        strokeWidth="1.5"
      />
      <path
        d="M3 7.19624L4.15904 7C4.53263 9.27557 4.81453 11.5571 5.03617 13.868C5.17974 13.8544 5.31283 13.8311 5.44645 13.8311C6.58348 13.8278 7.72068 13.8278 8.85806 13.8311C9.0017 13.8344 9.14456 13.8541 9.28405 13.8898C9.80069 14.011 10.0794 14.2986 10.0857 14.8438C10.1051 16.5252 10.0931 18.2066 10.0931 19.9032H8.92618V16.2719H5.2421C5.28559 17.4787 5.32908 18.6812 5.37257 19.9021H4.18838C4.18419 19.8478 4.17685 19.7967 4.17633 19.745C4.16561 17.7309 4.04877 15.7189 3.82631 13.718C3.58895 11.6262 3.30234 9.53976 3.04035 7.4512C3.03095 7.40596 3.01798 7.36159 3.00157 7.31856L3 7.19624Z"
        fill="#808191"
      />
      <path
        d="M13.626 18.7585H14.816V19.9034H11.1813V18.7677H12.3724V11.8716H7.51562V9.58081H18.4834V11.8629H13.626V18.7585Z"
        fill="#BFC0C8"
      />
      <path
        d="M17.0855 19.9016H15.9033V19.6926C15.9033 18.162 15.9033 16.6315 15.9033 15.1009C15.9045 14.9657 15.9147 14.8307 15.9337 14.697C15.9914 14.2828 16.2284 14.0216 16.6121 13.9217C16.8336 13.8637 17.061 13.8327 17.2894 13.8295C18.3296 13.8202 19.3691 13.824 20.4093 13.8295C20.5849 13.8295 20.7605 13.8533 20.9298 13.8658C21.2208 11.5857 21.5123 9.30291 21.8059 7L23.0001 7.21715C22.3521 11.4277 21.8672 15.6373 21.8211 19.9032H20.6336C20.6771 18.6904 20.7201 17.489 20.7636 16.2741H17.0871L17.0855 19.9016Z"
        fill="#808191"
      />
    </svg>
  );
};

export const TableBlue = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M7 1H19C22.3137 1 25 3.68629 25 7V19C25 22.3137 22.3137 25 19 25H7C3.68629 25 1 22.3137 1 19V7C1 3.68629 3.68629 1 7 1Z"
        fill="#4263EB"
        stroke="#4263EB"
        strokeWidth="1.5"
      />
      <path
        d="M3 6.97408L4.15904 6.77783C4.53263 9.0534 4.81453 11.3349 5.03617 13.6459C5.17974 13.6323 5.31283 13.6089 5.44645 13.6089C6.58348 13.6056 7.72068 13.6056 8.85806 13.6089C9.0017 13.6122 9.14456 13.6319 9.28405 13.6676C9.80069 13.7888 10.0794 14.0764 10.0857 14.6216C10.1051 16.303 10.0931 17.9844 10.0931 19.6811H8.92618V16.0497H5.2421C5.28559 17.2565 5.32908 18.459 5.37257 19.68H4.18838C4.18419 19.6256 4.17685 19.5745 4.17633 19.5229C4.16561 17.5087 4.04877 15.4967 3.82631 13.4958C3.58895 11.404 3.30234 9.3176 3.04035 7.22903C3.03095 7.18379 3.01798 7.13943 3.00157 7.09639L3 6.97408Z"
        fill="white"
      />
      <path
        d="M13.626 18.5363H14.816V19.6812H11.1813V18.5455H12.3724V11.6495H7.51562V9.35864H18.4834V11.6408H13.626V18.5363Z"
        fill="white"
      />
      <path
        d="M17.0855 19.6794H15.9033V19.4704C15.9033 17.9399 15.9033 16.4093 15.9033 14.8787C15.9045 14.7435 15.9147 14.6086 15.9337 14.4748C15.9914 14.0606 16.2284 13.7995 16.6121 13.6996C16.8336 13.6415 17.061 13.6105 17.2894 13.6073C18.3296 13.5981 19.3691 13.6019 20.4093 13.6073C20.5849 13.6073 20.7605 13.6312 20.9298 13.6437C21.2208 11.3636 21.5123 9.08074 21.8059 6.77783L23.0001 6.99498C22.3521 11.2056 21.8672 15.4151 21.8211 19.6811H20.6336C20.6771 18.4683 20.7201 17.2669 20.7636 16.0519H17.0871L17.0855 19.6794Z"
        fill="white"
      />
    </svg>
  );
};

export const AccessoriesWhite = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M7 1H19C22.3137 1 25 3.68629 25 7V19C25 22.3137 22.3137 25 19 25H7C3.68629 25 1 22.3137 1 19V7C1 3.68629 3.68629 1 7 1Z"
        stroke="#808191"
        strokeWidth="1.5"
      />
      <g clipPath="url(#clip0_641_1666)">
        <path
          d="M3.99951 21.8492C4.13799 21.4736 4.40696 21.3244 4.80408 21.3464C5.16036 21.3661 5.51852 21.3539 5.87574 21.3497C6.48598 21.3427 6.8831 20.9423 6.88826 20.3316C6.88826 20.14 6.88826 19.9485 6.88826 19.749H7.85853C7.85853 19.9368 7.85853 20.1217 7.85853 20.3072C7.86135 20.9512 8.25471 21.3492 8.89921 21.3497C11.0898 21.3516 13.2804 21.3516 15.471 21.3497C16.1342 21.3497 16.5285 20.9526 16.5332 20.2884C16.5332 20.2184 16.5332 20.1476 16.5332 20.0678H17.4955C17.4955 20.1645 17.4955 20.2611 17.4955 20.3578C17.5016 20.915 17.8908 21.3328 18.4498 21.3436C19.1112 21.3582 19.7736 21.3507 20.4354 21.3436C20.6847 21.3436 20.8781 21.2295 20.9724 20.9901C21.0668 20.7507 21.0081 20.5409 20.8265 20.3654C20.7326 20.2766 20.6331 20.1973 20.5359 20.1133L20.565 20.0565C20.7715 20.0565 20.9781 20.0565 21.1846 20.0565C21.2078 20.0589 21.2294 20.0693 21.2456 20.0861C21.4522 20.301 21.6864 20.4968 21.8559 20.7371C22.1558 21.1573 21.953 21.737 21.47 21.9257L21.325 21.9834H3.99951V21.8492Z"
          fill="#BFC0C8"
        />
        <path
          d="M21.3557 18.1213C21.2914 18.126 21.2567 18.1307 21.2219 18.1307C19.7339 18.1307 18.2463 18.1274 16.7583 18.1307C15.2069 18.1339 13.7508 17.7453 12.3543 17.0909C11.3958 16.6422 10.441 16.184 9.46695 15.7719C8.37698 15.3109 7.22834 15.0617 6.04871 14.9589C6.01491 14.956 5.98158 14.9476 5.91211 14.9354C5.94872 14.4937 5.9567 14.0538 6.02759 13.6239C6.14306 12.9197 6.31909 12.2269 6.43081 11.5232C6.50977 11.0262 6.55369 10.5243 6.56224 10.0211C6.58102 8.86779 6.56835 7.71351 6.56882 6.5597C6.56882 6.24332 6.60965 6.18418 6.91242 6.07292C8.45647 5.51245 10.0007 4.95057 11.545 4.38727C11.5882 4.37178 11.6328 4.36005 11.6948 4.34033V5.92553C11.507 5.92553 11.3141 5.92553 11.1226 5.92553C10.8902 5.92553 10.7447 6.05603 10.7494 6.25412C10.7541 6.44188 10.8958 6.56299 11.1197 6.56534C11.3075 6.56534 11.4929 6.56534 11.6948 6.56534V7.53467C11.507 7.53467 11.3192 7.53467 11.1343 7.53467C10.8935 7.53701 10.7513 7.65437 10.7494 7.8487C10.7475 8.04304 10.8968 8.17307 11.1432 8.17729C11.3131 8.17729 11.4831 8.17729 11.6525 8.18058C11.6719 8.18462 11.6907 8.1906 11.7089 8.19841V9.05696C11.5023 9.08184 11.2826 9.10672 11.0639 9.13583C10.9273 9.15366 10.8001 9.21234 10.7766 9.3541C10.7602 9.45268 10.7743 9.59209 10.8348 9.65734C10.8954 9.72259 11.0381 9.76812 11.1432 9.76624C11.3634 9.76202 11.5826 9.72165 11.8074 9.69536C11.8722 9.99109 11.9342 10.2751 12.0013 10.5807L11.3789 10.7407C11.1488 10.7999 11.0329 10.9524 11.0789 11.1369C11.1282 11.3355 11.2986 11.4186 11.538 11.3622C11.7539 11.3101 11.9684 11.2557 12.1952 11.1994L12.6425 12.2015C12.5111 12.2574 12.3825 12.3095 12.2562 12.3672C12.0684 12.4531 11.991 12.6254 12.0614 12.7972C12.1318 12.969 12.3116 13.0319 12.5026 12.9578C12.6594 12.8958 12.8134 12.8273 12.9622 12.7644L13.7311 13.7858C13.6372 13.8642 13.5377 13.9421 13.4438 14.028C13.2964 14.1632 13.279 14.3402 13.394 14.4819C13.509 14.6237 13.6907 14.6406 13.8489 14.5223C13.9611 14.4388 14.0667 14.3458 14.1775 14.2538L15.1844 15.072C15.1229 15.1659 15.0553 15.2677 14.9924 15.371C14.8839 15.5498 14.9177 15.7324 15.0741 15.8338C15.2219 15.9277 15.4026 15.8902 15.5209 15.731C15.596 15.6287 15.6646 15.5207 15.7355 15.4161C15.9889 15.5423 16.2255 15.6686 16.4691 15.7799C17.0033 16.0239 17.5408 15.8226 17.7901 15.2926C17.8417 15.1818 17.8938 15.071 17.9548 14.942C18.1463 15.0072 18.3304 15.0706 18.5181 15.1349C19.1589 15.3569 19.8005 15.5771 20.4427 15.8014C21.0281 16.0066 21.3524 16.4586 21.3576 17.0759C21.358 17.4195 21.3557 17.7655 21.3557 18.1213Z"
          fill="#808191"
        />
        <path
          d="M21.3474 18.7802V19.4106C21.3005 19.4148 21.262 19.4214 21.2225 19.4214C19.7295 19.4214 18.2362 19.4214 16.7425 19.4214C15.1183 19.4186 13.6031 18.983 12.1493 18.2845C11.2748 17.8644 10.3965 17.4494 9.50372 17.0711C8.43628 16.619 7.31392 16.3622 6.15871 16.2557C6.08876 16.2496 6.01788 16.2369 5.94043 16.2257V15.5835C6.26902 15.6276 6.59056 15.6647 6.9107 15.7159C8.32409 15.9421 9.62905 16.4801 10.903 17.1077C11.8052 17.5517 12.7084 17.9939 13.6726 18.3014C14.7522 18.6464 15.8638 18.7806 16.9941 18.7802H21.3493H21.3474Z"
          fill="#808191"
        />
        <path
          d="M5.94022 16.8662C6.34392 16.9254 6.73822 16.9709 7.12549 17.0422C7.95348 17.1962 8.76253 17.4388 9.53872 17.7656C9.6481 17.8125 9.69222 17.8553 9.66828 17.9811C9.62134 18.2336 9.59318 18.4899 9.55797 18.7443C9.52276 18.9987 9.41715 19.0992 9.15052 19.1001C8.52433 19.1001 7.8986 19.1001 7.27288 19.1001C6.95697 19.1001 6.64105 19.1001 6.32514 19.1001C6.0435 19.0973 5.93318 18.9828 5.93271 18.7021C5.93271 18.1524 5.93271 17.6022 5.93271 17.0526C5.93037 17.0028 5.93553 16.9512 5.94022 16.8662Z"
          fill="#808191"
        />
        <path
          d="M12.9953 5.91952H12.3579V5.39331C12.3579 5.03186 12.3743 4.66901 12.3513 4.3085C12.3382 4.10337 12.433 4.04188 12.5977 4.00761C12.6691 3.99021 12.7443 3.99799 12.8106 4.02963C12.8769 4.06128 12.9302 4.11486 12.9615 4.18129C12.9804 4.21755 12.9915 4.25737 12.9939 4.29818C12.9963 4.83377 12.9953 5.36984 12.9953 5.91952Z"
          fill="#808191"
        />
        <path
          d="M14.6802 13.8341L15.19 13.4065L15.9157 13.9806L15.5472 14.5368L14.6802 13.8341Z"
          fill="#808191"
        />
        <path
          d="M16.462 14.3203L17.3262 14.7231C17.3269 14.7368 17.3258 14.7505 17.3229 14.7639C17.1318 15.2188 17.0558 15.3849 16.5127 15.0878C16.3812 15.016 16.2484 14.947 16.0991 14.8653L16.462 14.3203Z"
          fill="#808191"
        />
        <path
          d="M14.7351 12.9493L14.2291 13.3717L13.563 12.508C13.7667 12.4193 13.9385 12.34 14.1174 12.2705C14.1378 12.2667 14.1588 12.2679 14.1786 12.2739C14.1985 12.28 14.2166 12.2907 14.2314 12.3052C14.3999 12.5137 14.5614 12.7268 14.7351 12.9493Z"
          fill="#808191"
        />
        <path
          d="M12.3672 6.57202H12.9863V7.52305H12.3672V6.57202Z"
          fill="#808191"
        />
        <path
          d="M13.839 11.6885L13.2358 11.9448L12.8223 11.0436L13.455 10.8821C13.5813 11.1468 13.7052 11.4083 13.839 11.6885Z"
          fill="#808191"
        />
        <path
          d="M12.4458 9.6119L13.0837 9.53491C13.1405 9.78088 13.195 10.0165 13.2532 10.2677L12.6289 10.4244C12.5678 10.1536 12.5101 9.89636 12.4458 9.6119Z"
          fill="#808191"
        />
        <path
          d="M13.0084 8.18945C13.0084 8.39787 13.0126 8.6016 13.0042 8.80438C12.9993 8.82663 12.9889 8.84731 12.974 8.86453C12.9591 8.88174 12.9401 8.89495 12.9187 8.90296C12.7474 8.93159 12.5733 8.94661 12.3794 8.9682V8.18945H13.0084Z"
          fill="#808191"
        />
      </g>
      <defs>
        <clipPath id="clip0_641_1666">
          <rect
            width="18"
            height="17.9901"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AccessoriesBlue = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M7 1H19C22.3137 1 25 3.68629 25 7V19C25 22.3137 22.3137 25 19 25H7C3.68629 25 1 22.3137 1 19V7C1 3.68629 3.68629 1 7 1Z"
        fill="#4263EB"
        stroke="#4263EB"
        strokeWidth="1.5"
      />
      <g clipPath="url(#clip0_641_1665)">
        <path
          d="M3.99951 21.8492C4.13799 21.4736 4.40696 21.3244 4.80408 21.3464C5.16036 21.3661 5.51852 21.3539 5.87574 21.3497C6.48598 21.3427 6.8831 20.9423 6.88826 20.3316C6.88826 20.14 6.88826 19.9485 6.88826 19.749H7.85853C7.85853 19.9368 7.85853 20.1217 7.85853 20.3072C7.86135 20.9512 8.25471 21.3492 8.89921 21.3497C11.0898 21.3516 13.2804 21.3516 15.471 21.3497C16.1342 21.3497 16.5285 20.9526 16.5332 20.2884C16.5332 20.2184 16.5332 20.1476 16.5332 20.0678H17.4955C17.4955 20.1645 17.4955 20.2611 17.4955 20.3578C17.5016 20.915 17.8908 21.3328 18.4498 21.3436C19.1112 21.3582 19.7736 21.3507 20.4354 21.3436C20.6847 21.3436 20.8781 21.2295 20.9724 20.9901C21.0668 20.7507 21.0081 20.5409 20.8265 20.3654C20.7326 20.2766 20.6331 20.1973 20.5359 20.1133L20.565 20.0565C20.7715 20.0565 20.9781 20.0565 21.1846 20.0565C21.2078 20.0589 21.2294 20.0693 21.2456 20.0861C21.4522 20.301 21.6864 20.4968 21.8559 20.7371C22.1558 21.1573 21.953 21.737 21.47 21.9257L21.325 21.9834H3.99951V21.8492Z"
          fill="white"
        />
        <path
          d="M21.3557 18.1213C21.2914 18.126 21.2567 18.1307 21.2219 18.1307C19.7339 18.1307 18.2463 18.1274 16.7583 18.1307C15.2069 18.1339 13.7508 17.7453 12.3543 17.0909C11.3958 16.6422 10.441 16.184 9.46695 15.7719C8.37698 15.3109 7.22834 15.0617 6.04871 14.9589C6.01491 14.956 5.98158 14.9476 5.91211 14.9354C5.94872 14.4937 5.9567 14.0538 6.02759 13.6239C6.14306 12.9197 6.31909 12.2269 6.43081 11.5232C6.50977 11.0262 6.55369 10.5243 6.56224 10.0211C6.58102 8.86779 6.56835 7.71351 6.56882 6.5597C6.56882 6.24332 6.60965 6.18418 6.91242 6.07292C8.45647 5.51245 10.0007 4.95057 11.545 4.38727C11.5882 4.37178 11.6328 4.36005 11.6948 4.34033V5.92553C11.507 5.92553 11.3141 5.92553 11.1226 5.92553C10.8902 5.92553 10.7447 6.05603 10.7494 6.25412C10.7541 6.44188 10.8958 6.56299 11.1197 6.56534C11.3075 6.56534 11.4929 6.56534 11.6948 6.56534V7.53467C11.507 7.53467 11.3192 7.53467 11.1343 7.53467C10.8935 7.53701 10.7513 7.65437 10.7494 7.8487C10.7475 8.04304 10.8968 8.17307 11.1432 8.17729C11.3131 8.17729 11.4831 8.17729 11.6525 8.18058C11.6719 8.18462 11.6907 8.1906 11.7089 8.19841V9.05696C11.5023 9.08184 11.2826 9.10672 11.0639 9.13583C10.9273 9.15366 10.8001 9.21234 10.7766 9.3541C10.7602 9.45268 10.7743 9.59209 10.8348 9.65734C10.8954 9.72259 11.0381 9.76812 11.1432 9.76624C11.3634 9.76202 11.5826 9.72165 11.8074 9.69536C11.8722 9.99109 11.9342 10.2751 12.0013 10.5807L11.3789 10.7407C11.1488 10.7999 11.0329 10.9524 11.0789 11.1369C11.1282 11.3355 11.2986 11.4186 11.538 11.3622C11.7539 11.3101 11.9684 11.2557 12.1952 11.1994L12.6425 12.2015C12.5111 12.2574 12.3825 12.3095 12.2562 12.3672C12.0684 12.4531 11.991 12.6254 12.0614 12.7972C12.1318 12.969 12.3116 13.0319 12.5026 12.9578C12.6594 12.8958 12.8134 12.8273 12.9622 12.7644L13.7311 13.7858C13.6372 13.8642 13.5377 13.9421 13.4438 14.028C13.2964 14.1632 13.279 14.3402 13.394 14.4819C13.509 14.6237 13.6907 14.6406 13.8489 14.5223C13.9611 14.4388 14.0667 14.3458 14.1775 14.2538L15.1844 15.072C15.1229 15.1659 15.0553 15.2677 14.9924 15.371C14.8839 15.5498 14.9177 15.7324 15.0741 15.8338C15.2219 15.9277 15.4026 15.8902 15.5209 15.731C15.596 15.6287 15.6646 15.5207 15.7355 15.4161C15.9889 15.5423 16.2255 15.6686 16.4691 15.7799C17.0033 16.0239 17.5408 15.8226 17.7901 15.2926C17.8417 15.1818 17.8938 15.071 17.9548 14.942C18.1463 15.0072 18.3304 15.0706 18.5181 15.1349C19.1589 15.3569 19.8005 15.5771 20.4427 15.8014C21.0281 16.0066 21.3524 16.4586 21.3576 17.0759C21.358 17.4195 21.3557 17.7655 21.3557 18.1213Z"
          fill="white"
        />
        <path
          d="M21.3474 18.7802V19.4106C21.3005 19.4148 21.262 19.4214 21.2225 19.4214C19.7295 19.4214 18.2362 19.4214 16.7425 19.4214C15.1183 19.4186 13.6031 18.983 12.1493 18.2845C11.2748 17.8644 10.3965 17.4494 9.50372 17.0711C8.43628 16.619 7.31392 16.3622 6.15871 16.2557C6.08876 16.2496 6.01788 16.2369 5.94043 16.2257V15.5835C6.26902 15.6276 6.59056 15.6647 6.9107 15.7159C8.32409 15.9421 9.62905 16.4801 10.903 17.1077C11.8052 17.5517 12.7084 17.9939 13.6726 18.3014C14.7522 18.6464 15.8638 18.7806 16.9941 18.7802H21.3493H21.3474Z"
          fill="white"
        />
        <path
          d="M5.94022 16.8662C6.34392 16.9254 6.73822 16.9709 7.12549 17.0422C7.95348 17.1962 8.76253 17.4388 9.53872 17.7656C9.6481 17.8125 9.69222 17.8553 9.66828 17.9811C9.62134 18.2336 9.59318 18.4899 9.55797 18.7443C9.52276 18.9987 9.41715 19.0992 9.15052 19.1001C8.52433 19.1001 7.8986 19.1001 7.27288 19.1001C6.95697 19.1001 6.64105 19.1001 6.32514 19.1001C6.0435 19.0973 5.93318 18.9828 5.93271 18.7021C5.93271 18.1524 5.93271 17.6022 5.93271 17.0526C5.93037 17.0028 5.93553 16.9512 5.94022 16.8662Z"
          fill="white"
        />
        <path
          d="M12.9953 5.91952H12.3579V5.39331C12.3579 5.03186 12.3743 4.66901 12.3513 4.3085C12.3382 4.10337 12.433 4.04188 12.5977 4.00761C12.6691 3.99021 12.7443 3.99799 12.8106 4.02963C12.8769 4.06128 12.9302 4.11486 12.9615 4.18129C12.9804 4.21755 12.9915 4.25737 12.9939 4.29818C12.9963 4.83377 12.9953 5.36984 12.9953 5.91952Z"
          fill="white"
        />
        <path
          d="M14.6802 13.8344L15.19 13.4067L15.9157 13.9808L15.5472 14.5371L14.6802 13.8344Z"
          fill="white"
        />
        <path
          d="M16.462 14.3203L17.3262 14.7231C17.3269 14.7368 17.3258 14.7505 17.3229 14.7639C17.1318 15.2188 17.0558 15.3849 16.5127 15.0878C16.3812 15.016 16.2484 14.947 16.0991 14.8653L16.462 14.3203Z"
          fill="white"
        />
        <path
          d="M14.7351 12.9495L14.2291 13.372L13.563 12.5083C13.7667 12.4195 13.9385 12.3402 14.1174 12.2707C14.1378 12.2669 14.1588 12.2681 14.1786 12.2742C14.1985 12.2802 14.2166 12.2909 14.2314 12.3055C14.3999 12.5139 14.5614 12.727 14.7351 12.9495Z"
          fill="white"
        />
        <path
          d="M12.3672 6.57178H12.9863V7.5228H12.3672V6.57178Z"
          fill="white"
        />
        <path
          d="M13.839 11.6883L13.2358 11.9446L12.8223 11.0433L13.455 10.8818C13.5813 11.1466 13.7052 11.408 13.839 11.6883Z"
          fill="white"
        />
        <path
          d="M12.4458 9.61165L13.0837 9.53467C13.1405 9.78064 13.195 10.0163 13.2532 10.2674L12.6289 10.4242C12.5678 10.1534 12.5101 9.89611 12.4458 9.61165Z"
          fill="white"
        />
        <path
          d="M13.0084 8.18945C13.0084 8.39787 13.0126 8.6016 13.0042 8.80438C12.9993 8.82663 12.9889 8.84731 12.974 8.86453C12.9591 8.88174 12.9401 8.89495 12.9187 8.90296C12.7474 8.93159 12.5733 8.94661 12.3794 8.9682V8.18945H13.0084Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_641_1665">
          <rect
            width="18"
            height="17.9901"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Card = ({ color }) => {
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 15.5C18 15.2239 18.2239 15 18.5 15H20.1C20.3761 15 20.6 15.2239 20.6 15.5C20.6 15.7761 20.3761 16 20.1 16H18.5C18.2239 16 18 15.7761 18 15.5Z"
        fill={color}
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.35286C0 5.96301 0.316034 5.64697 0.705882 5.64697H23.2941C23.684 5.64697 24 5.96301 24 6.35286C24 6.7427 23.684 7.05874 23.2941 7.05874H0.705882C0.316034 7.05874 0 6.7427 0 6.35286Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.2011 2.18616C1.68013 2.69146 1.41176 3.62347 1.41176 5.56962V14.6767C1.41176 16.6232 1.68026 17.5545 2.20062 18.0583C2.72838 18.5692 3.70644 18.829 5.71852 18.8234L5.72047 18.8234L18.2795 18.8234C20.2915 18.8234 21.2704 18.5617 21.7989 18.049C22.3199 17.5437 22.5882 16.6117 22.5882 14.6656V5.56962C22.5882 3.62341 22.3198 2.69185 21.798 2.18662C21.268 1.67358 20.2862 1.41176 18.2682 1.41176H5.72047C3.70849 1.41176 2.72965 1.67351 2.2011 2.18616ZM1.21819 1.17276C2.19459 0.225737 3.72304 0 5.72047 0H18.2682C20.271 0 21.8021 0.225666 22.7799 1.1723C23.7658 2.12675 24 3.62705 24 5.56962V14.6656C24 16.6082 23.7658 18.1081 22.7818 19.0624C21.8054 20.0095 20.277 20.2352 18.2795 20.2352H5.72111C3.72442 20.2406 2.19564 20.0184 1.21867 19.0726C0.234095 18.1194 0 16.6189 0 14.6767V5.56962C0 3.62699 0.234227 2.12713 1.21819 1.17276Z"
        fill={color}
      />
      <path
        d="M3 16V12H4.42469C4.72484 12 4.98387 12.0493 5.20179 12.1479C5.42382 12.2466 5.59651 12.3854 5.71986 12.5644C5.84321 12.7397 5.90489 12.9479 5.90489 13.189C5.90489 13.4521 5.82882 13.684 5.67669 13.8849C5.52867 14.0858 5.3272 14.2283 5.07228 14.3123L5.96656 16H5.10311L4.31984 14.411H3.77094V16H3ZM3.77094 13.8082H4.42469C4.64261 13.8082 4.81324 13.7553 4.93659 13.6493C5.05994 13.5434 5.12162 13.3973 5.12162 13.211C5.12162 13.021 5.05994 12.8731 4.93659 12.7671C4.81324 12.6575 4.64261 12.6027 4.42469 12.6027H3.77094V13.8082Z"
        fill={color}
      />
      <path
        d="M6.41438 16V12H9.21442V12.6356H7.17298V13.7041H9.05406V14.3397H7.18531V16H6.41438Z"
        fill={color}
      />
      <path
        d="M9.86576 16V15.3973H10.7724V12.6027H9.86576V12H12.4561V12.6027H11.5495V15.3973H12.4561V16H9.86576Z"
        fill={color}
      />
      <path
        d="M13.163 16V12H14.5013C14.8056 12 15.0687 12.0511 15.2907 12.1534C15.5169 12.2557 15.6916 12.4 15.815 12.5863C15.9383 12.7726 16 12.9936 16 13.2493V14.7452C16 14.9973 15.9383 15.2183 15.815 15.4082C15.6916 15.5945 15.5169 15.7406 15.2907 15.8466C15.0687 15.9489 14.8056 16 14.5013 16H13.163ZM13.9339 15.3699H14.5013C14.7233 15.3699 14.9001 15.3151 15.0317 15.2055C15.1633 15.0922 15.2291 14.9388 15.2291 14.7452V13.2493C15.2291 13.0594 15.1633 12.9096 15.0317 12.8C14.9001 12.6868 14.7233 12.6301 14.5013 12.6301H13.9339V15.3699Z"
        fill={color}
      />
    </svg>
  );
};

export const LocationBlu = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 8.47783C19.45 3.85783 15.42 1.77783 11.88 1.77783C11.88 1.77783 11.88 1.77783 11.87 1.77783C8.33998 1.77783 4.29998 3.84783 3.24998 8.46783C2.07998 13.6278 5.23998 17.9978 8.09998 20.7478C9.15998 21.7678 10.52 22.2778 11.88 22.2778C13.24 22.2778 14.6 21.7678 15.65 20.7478C18.51 17.9978 21.67 13.6378 20.5 8.47783ZM11.88 13.4878C10.14 13.4878 8.72998 12.0778 8.72998 10.3378C8.72998 8.59783 10.14 7.18783 11.88 7.18783C13.62 7.18783 15.03 8.59783 15.03 10.3378C15.03 12.0778 13.62 13.4878 11.88 13.4878Z"
        fill="#4263EB"
      />
    </svg>
  );
};

export const Settings = ({ color }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_207_9276)">
        <g clipPath="url(#clip1_207_9276)">
          <path
            d="M20.5204 14.7533L19.0497 13.6033C19.0684 13.426 19.0844 13.2187 19.0844 12.9993C19.0844 12.78 19.069 12.5727 19.0497 12.3953L20.5217 11.2447C20.7951 11.0287 20.8697 10.6453 20.6957 10.326L19.1664 7.68C19.003 7.38134 18.645 7.228 18.2817 7.362L16.5464 8.05866C16.2137 7.81866 15.865 7.616 15.5044 7.454L15.2404 5.61334C15.197 5.264 14.893 5 14.5337 5H11.4671C11.1077 5 10.8044 5.264 10.7617 5.608L10.4971 7.45534C10.1477 7.61269 9.8044 7.81269 9.45706 8.06L7.71706 7.36134C7.39103 7.23534 7.00103 7.37666 6.83903 7.674L5.30771 10.3233C5.12706 10.6287 5.20171 11.0253 5.48106 11.2467L6.95171 12.3967C6.92837 12.6213 6.91706 12.8167 6.91706 13C6.91706 13.1834 6.9284 13.3787 6.95171 13.604L5.47971 14.7547C5.20637 14.9713 5.13237 15.3547 5.30637 15.6733L6.83571 18.3193C6.99906 18.6173 7.35371 18.772 7.72037 18.6373L9.45571 17.9407C9.78771 18.18 10.1364 18.3827 10.4971 18.5453L10.7611 20.3853C10.8044 20.736 11.1077 21 11.4677 21H14.5344C14.8937 21 15.1977 20.736 15.2404 20.392L15.505 18.5453C15.8544 18.3873 16.197 18.188 16.545 17.94L18.285 18.6387C18.369 18.6713 18.4564 18.688 18.5464 18.688C18.805 18.688 19.043 18.5467 19.163 18.3267L20.699 15.6667C20.8697 15.3547 20.795 14.9713 20.5204 14.7533ZM13.0004 15.6667C11.5297 15.6667 10.3337 14.4707 10.3337 13C10.3337 11.5293 11.5297 10.3333 13.0004 10.3333C14.471 10.3333 15.667 11.5293 15.667 13C15.667 14.4707 14.471 15.6667 13.0004 15.6667Z"
            fill={color}
          />
        </g>
        <path
          d="M7 1.22217H19C22.3137 1.22217 25 3.90846 25 7.22217V19.2222C25 22.5359 22.3137 25.2222 19 25.2222H7C3.68629 25.2222 1 22.5359 1 19.2222V7.22217C1 3.90846 3.68629 1.22217 7 1.22217Z"
          stroke={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_207_9276">
          <rect width="26" height="26" fill="white" />
        </clipPath>
        <clipPath id="clip1_207_9276">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ShiftIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M14.3438 5.80029C14.3438 5.58895 14.2598 5.38626 14.1104 5.23682C13.9609 5.08737 13.7582 5.00342 13.5469 5.00342C13.3355 5.00342 13.1328 5.08737 12.9834 5.23682C12.834 5.38626 12.75 5.58895 12.75 5.80029V12.1753C12.75 12.3866 12.834 12.5893 12.9834 12.7388C13.1328 12.8882 13.3355 12.9722 13.5469 12.9722H18.3281C18.5395 12.9722 18.7422 12.8882 18.8916 12.7388C19.041 12.5893 19.125 12.3866 19.125 12.1753C19.125 11.9639 19.041 11.7613 18.8916 11.6118C18.7422 11.4624 18.5395 11.3784 18.3281 11.3784H14.3438V5.80029ZM7.96875 0.222168C6.70068 0.222168 5.48455 0.725906 4.5879 1.62256C3.69124 2.51922 3.1875 3.73535 3.1875 5.00342V11.5442C3.70517 11.3975 4.24541 11.3472 4.78125 11.3959V5.00342C4.78125 4.15804 5.11707 3.34729 5.71485 2.74952C6.31262 2.15174 7.12337 1.81592 7.96875 1.81592H20.7188C21.5641 1.81592 22.3749 2.15174 22.9727 2.74952C23.5704 3.34729 23.9062 4.15804 23.9062 5.00342V17.7534C23.9062 18.5988 23.5704 19.4095 22.9727 20.0073C22.3749 20.6051 21.5641 20.9409 20.7188 20.9409H15.7909C15.8865 21.2597 15.9375 21.5944 15.9375 21.937C15.9376 22.1369 15.9243 22.3366 15.8977 22.5347H20.7188C21.9868 22.5347 23.2029 22.0309 24.0996 21.1343C24.9963 20.2376 25.5 19.0215 25.5 17.7534V5.00342C25.5 3.73535 24.9963 2.51922 24.0996 1.62256C23.2029 0.725906 21.9868 0.222168 20.7188 0.222168H7.96875Z"
        fill={color}
      />
      <path
        d="M5.45014 18.338C5.11176 18.4782 4.74908 18.5503 4.38281 18.5503C3.64311 18.5503 2.9337 18.2564 2.41065 17.7334C1.8876 17.2103 1.59375 16.5009 1.59375 15.7612C1.59375 15.0215 1.8876 14.3121 2.41065 13.7891C2.9337 13.266 3.64311 12.9722 4.38281 12.9722C4.74908 12.9722 5.11176 13.0443 5.45014 13.1845C5.78853 13.3246 6.09599 13.5301 6.35498 13.7891C6.61397 14.0481 6.81941 14.3555 6.95957 14.6939C7.09973 15.0323 7.17188 15.395 7.17188 15.7612C7.17188 16.1275 7.09973 16.4902 6.95957 16.8286C6.81941 17.1669 6.61397 17.4744 6.35498 17.7334C6.09599 17.9924 5.78853 18.1978 5.45014 18.338Z"
        fill={color}
      />
      <path
        d="M9.5625 22.235C9.5625 23.9722 8.19666 25.7222 4.78125 25.7222C1.36584 25.7222 0 23.977 0 22.2366C0 21.0812 0.918 20.144 2.04956 20.144H7.51294C8.6445 20.144 9.5625 21.0812 9.5625 22.235Z"
        fill={color}
      />
      <path
        d="M10.3227 24.9253H10.3594C13.2058 24.9253 14.3453 23.4256 14.3453 21.937C14.3453 20.9473 13.5819 20.144 12.6384 20.144H10.5124C10.9204 20.7417 11.1562 21.4653 11.1562 22.235C11.1604 23.196 10.8694 24.135 10.3227 24.9253Z"
        fill={color}
      />
      <path
        d="M12.1665 17.9668C11.7929 18.3404 11.2862 18.5503 10.7578 18.5503C10.2295 18.5503 9.72273 18.3404 9.34912 17.9668C8.97552 17.5932 8.76562 17.0865 8.76562 16.5581C8.76562 16.0297 8.97552 15.523 9.34912 15.1494C9.72273 14.7758 10.2295 14.5659 10.7578 14.5659C11.2862 14.5659 11.7929 14.7758 12.1665 15.1494C12.5401 15.523 12.75 16.0297 12.75 16.5581C12.75 17.0865 12.5401 17.5932 12.1665 17.9668Z"
        fill={color}
      />
    </svg>
  );
};

export const AddPlus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      class="feather feather-plus text-white"
    >
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
};

export const CompanyIcon = ({className = ""}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M23.681 5.21727H17.859L17.5705 3.23629C17.4442 2.36997 16.6889 1.71661 15.8134 1.71661H10.1867C9.31115 1.71661 8.55578 2.36997 8.42959 3.23639L8.1411 5.21727H2.31903C1.0403 5.21727 0 6.25757 0 7.53625V21.9643C0 23.243 1.0403 24.2833 2.31903 24.2833H23.681C24.9597 24.2833 26 23.243 26 21.9643V7.53625C26 6.25757 24.9597 5.21727 23.681 5.21727ZM9.94307 3.45679C9.96054 3.33664 10.0653 3.24604 10.1867 3.24604H15.8134C15.9349 3.24604 16.0396 3.33669 16.0571 3.45679L16.3135 5.21727H9.68668L9.94307 3.45679ZM24.4706 21.9644C24.4706 22.3997 24.1164 22.754 23.681 22.754H2.31903C1.88363 22.754 1.52938 22.3998 1.52938 21.9643V14.6749C2.20233 15.2007 3.04789 15.5151 3.96612 15.5151H9.94104V16.2629C9.94104 16.5453 10.0967 16.8047 10.3459 16.9376L12.6401 18.1611C12.7526 18.2211 12.8762 18.2511 13 18.2511C13.1237 18.2511 13.2474 18.2211 13.3599 18.1611L15.6541 16.9376C15.9033 16.8047 16.059 16.5453 16.059 16.2629V15.5152H22.0339C22.9521 15.5152 23.7977 15.2007 24.4706 14.675V21.9644ZM11.4705 15.804V13.595H14.5296V15.804L13 16.6198L11.4705 15.804ZM24.4706 11.549C24.4706 12.8927 23.3775 13.9858 22.0339 13.9858H16.059V12.8302C16.059 12.4079 15.7166 12.0655 15.2942 12.0655H10.7058C10.2835 12.0655 9.94104 12.4078 9.94104 12.8302V13.9858H3.96612C2.6225 13.9858 1.52938 12.8927 1.52938 11.5491V7.53625C1.52938 7.15529 1.8006 6.83648 2.16003 6.76275C2.21137 6.75218 2.26454 6.7467 2.31898 6.7467H23.681C23.7354 6.7467 23.7885 6.75223 23.8399 6.76275C24.1993 6.83653 24.4705 7.15534 24.4705 7.53625V11.549H24.4706Z"
        fill="#808191"
      />
    </svg>
  );
};
